import { SortOptions } from "../../../enum";

export const PROPERTY_TYPES = [
  { label: "Apartamento", value: 1 },
  { label: "Casa", value: 2 },
  { label: "Flat", value: 3 },
  { label: "Casa de condomínio", value: 4 },
];

export const CHARACTERISTIC_NAMES = [
  { filterName: "rooms", label: "Quarto" },
  { filterName: "bathrooms", label: "Banheiro" },
  { filterName: "garages", label: "Vaga de Garagem" },
];

export const ORDER_BY_OPTIONS = [
  SortOptions.HIGHEST_PRICE,
  SortOptions.LOWEST_PRICE,
];
